<div class="modal-header d-flex justify-content-between align-items-center border-0 pb-0">
  <div class="modal-title">
    <h4 class="modern-header mb-0">
      <i class="far fa-bell me-2"></i>
      Inventory Alerts
    </h4>
  </div>
  <button type="button" class="close-btn" aria-label="Close" (click)="bsModalRef.hide()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<div class="modal-body pb-0 pt-3" style="max-height: 70vh; overflow-y: auto;">
  @if (alerts.length === 0) {
    <div class="text-center text-muted my-4">
      <i class="far fa-bell fa-3x mb-3"></i>
      <h5>No new alerts</h5>
      <p>You'll be notified when back-in-stock items arrive.</p>
    </div>
  }

  @if (alerts.length > 0) {
    <div class="list-group list-group-flush mb-4 alerts-scroll-container">
      @for (alert of alerts; track alert) {
        <div class="list-group-item d-flex justify-content-between align-items-center py-3">
          <div class="me-3" style="flex: 1;">
            <h6 class="mb-2 text-primary">{{ alert.item_description }}</h6>
            <div class="d-flex">
              <div class="vendor-list text-muted small me-4">
                @for (vendor of splitVendors(alert.vendor); track vendor) {
                  <div class="vendor-line"><i class="fas fa-store me-1"></i> {{ vendor }}</div>
                }
              </div>
              <div class="d-flex align-items-center text-muted small">
                @if (alert.upc) {
                  <span class="me-3" title="UPC"><i class="fas fa-barcode me-1"></i> {{ alert.upc }}</span>
                }
                @if (alert.qty) {
                  <span class="me-3" title="Quantity Available"><i class="fas fa-boxes me-1"></i> Qty: {{ alert.qty }}</span>
                }
                <span title="Price"><i class="fas fa-tag me-1"></i> ${{ alert.price }}</span>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center">
            <button class="btn modern-btn primary-btn btn-sm me-2" (click)="copyAlert(alert)" tooltip="Copy to clipboard">
              <i class="fas fa-copy me-2"></i> Copy
            </button>
            <button class="btn modern-btn danger-btn btn-sm" (click)="dismissAlert(alert)" tooltip="Dismiss alert">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
        </div>
      }
    </div>
  }
</div>

<div class="modal-footer d-flex justify-content-end align-items-center gap-2 border-0 pt-0" style="border-top: none;">
  <button type="button" class="btn modern-btn secondary-btn px-4" (click)="bsModalRef.hide()">Close</button>
  @if (alerts.length > 0) {
    <button type="button" class="btn modern-btn danger-btn px-4" (click)="clearAll()">Clear All</button>
  }
</div>
